

// import React, { useState, useEffect } from "react";
// import { Button, Input, Select, Tag, Collapse, Empty } from "antd";
// import {
//   SearchOutlined,
//   CheckOutlined,
//   CloseOutlined,
//   QuestionCircleOutlined
// } from "@ant-design/icons";

// const { Option } = Select;
// const { Panel } = Collapse;

// export const SuggestionsData = ({ selectedStyles = [], onUpdateSelectedStyles }) => {

//   const allSuggestions = [
//     {
//       id: "degreeToSymbol",
//       label: "Convert 'degree' to °",
//       items: [
//         {
//           original: "10 degree",
//           suggested: "10°C",
//           line: "Line 5, Column 3",
//           status: "pending"
//         }
//       ]
//     },
//     {
//       id: "correctIE_EGPeriods",
//       label: "Correct i.e and e.g punctuation",
//       items: [
//         {
//           original: "i.e example",
//           suggested: "i.e. example",
//           line: "Line 8, Column 2",
//           status: "pending"
//         }
//       ]
//     }
//   ];

//   const [suggestions, setSuggestions] = useState([]);
//   const [filter, setFilter] = useState("all");
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     if (!selectedStyles || selectedStyles.length === 0) {
//       setSuggestions([]);
//       return;
//     }

//     const filtered = allSuggestions.filter((s) =>
//       selectedStyles.includes(s.id)
//     );

//     setSuggestions(filtered);

//   }, [selectedStyles]);

//   // ACCEPT SINGLE
//   const handleAccept = (suggestionId, index) => {
//     setSuggestions((prev) =>
//       prev.map((s) =>
//         s.id === suggestionId
//           ? {
//               ...s,
//               items: s.items.map((item, i) =>
//                 i === index ? { ...item, status: "accepted" } : item
//               )
//             }
//           : s
//       )
//     );
//   };

//   // REJECT SINGLE ITEM
//   const handleReject = (suggestionId, index) => {
//     setSuggestions((prev) =>
//       prev
//         .map((s) =>
//           s.id === suggestionId
//             ? {
//                 ...s,
//                 items: s.items.filter((_, i) => i !== index)
//               }
//             : s
//         )
//         .filter((s) => s.items.length > 0)
//     );

//     // Remove the style ID from parent selectedStyles if needed
//     if (onUpdateSelectedStyles) {
//       const styleId = suggestionId;
//       onUpdateSelectedStyles((prev) =>
//         prev.filter((id) => id !== styleId)
//       );
//     }
//   };

//   // ACCEPT ALL
//   const handleAcceptAll = (id) => {
//     setSuggestions((prev) =>
//       prev.map((s) =>
//         s.id === id
//           ? {
//               ...s,
//               items: s.items.map((item) =>
//                 item.status === "pending"
//                   ? { ...item, status: "accepted" }
//                   : item
//               )
//             }
//           : s
//       )
//     );
//   };

//   // REJECT ALL
//   const handleRejectAll = (id) => {
//     setSuggestions((prev) =>
//       prev.filter((s) => s.id !== id)
//     );

//     // Remove the style ID from parent selectedStyles
//     if (onUpdateSelectedStyles) {
//       onUpdateSelectedStyles((prev) => prev.filter((sid) => sid !== id));
//     }
//   };

//   const filteredSuggestions = suggestions
//     .filter((s) =>
//       s.label.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//     .filter((s) => {
//       if (filter === "all") return true;
//       return s.items.some((item) => item.status === filter);
//     });

//   const totalSuggestions = filteredSuggestions.reduce(
//     (sum, s) => sum + s.items.length,
//     0
//   );

//   const panelHeader = (suggestion) => {
//     const pendingCount = suggestion.items.filter(
//       (item) => item.status === "pending"
//     ).length;

//     return (
//       <div className="flex justify-between items-center w-full">
//         <div className="flex items-center gap-2">
//           <span className="font-bold">{suggestion.label}</span>
//           <Tag color="blue">{pendingCount}</Tag>
//         </div>
//         <div className="flex gap-2">
//           <Button
//             size="small"
//             type="primary"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleAcceptAll(suggestion.id);
//             }}
//           >
//             Accept All
//           </Button>
//           <Button
//             size="small"
//             danger
//             onClick={(e) => {
//               e.stopPropagation();
//               handleRejectAll(suggestion.id);
//             }}
//           >
//             Reject All
//           </Button>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-white h-full flex flex-col">
//       {/* HEADER */}
//       <div className="flex justify-between items-center p-4 border-b">
//         <h2 className="text-lg font-medium">
//           Suggestions ({totalSuggestions})
//         </h2>

//         <div className="flex gap-2">
//           <Input
//             placeholder="Search styles..."
//             className="w-64"
//             prefix={<SearchOutlined />}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <Select
//             value={filter}
//             onChange={setFilter}
//             className="w-32"
//           >
//             <Option value="all">All</Option>
//             <Option value="pending">Pending</Option>
//             <Option value="accepted">Accepted</Option>
//             <Option value="rejected">Rejected</Option>
//           </Select>
//         </div>
//       </div>

//       {/* BODY */}
//       {filteredSuggestions.length > 0 ? (
//         <div className="flex-1 overflow-auto p-3">
//           <Collapse
//             accordion={false}
//             bordered={false}
//             expandIconPosition="right"
//           >
//             {filteredSuggestions.map((suggestion) => (
//               <Panel
//                 header={panelHeader(suggestion)}
//                 key={suggestion.id}
//               >
//                 {suggestion.items.map((item, index) => (
//                   <div key={index} className="mb-4">
//                     <div className="grid grid-row-3 gap-3">
//                       {/* ORIGINAL */}
//                       <div className="flex gap-2">
//                         <div className="text-red text-sm mb-1">Original</div>
//                         <div className=" text-black font-bold">{item.original}</div>
//                       </div>

//                       {/* SUGGESTED */}
//                       <div className="flex gap-2">
//                         <div className="text-green text-sm mb-1">Suggested</div>
//                         <div className="text-black font-bold">{item.suggested}</div>
//                       </div>

//                       {/* ACTIONS */}
//                       <div className="flex flex-col justify-between">
//                         <div className="text-sm text-gray-500">{item.line}</div>
//                         <div className="flex gap-2 mt-2">
//                           <Button
//                             type="primary"
//                             icon={<CheckOutlined />}
//                             size="small"
//                             onClick={() => handleAccept(suggestion.id, index)}
//                             disabled={item.status !== "pending"}
//                           />
//                           <Button
//                             danger
//                             icon={<CloseOutlined />}
//                             size="small"
//                             onClick={() => handleReject(suggestion.id, index)}
//                           />
//                           <Button
//                             icon={<QuestionCircleOutlined />}
//                             size="small"
//                           />
//                         </div>
//                       </div>

//                     </div>
//                   </div>
//                 ))}
//               </Panel>
//             ))}
//           </Collapse>
//         </div>
//       ) : (
//         <div className="flex-1 flex items-center justify-center">
//           <Empty
//             description={
//               selectedStyles.length > 0
//                 ? "No suggestions found"
//                 : "Please select styles first"
//             }
//           />
//         </div>
//       )}
//     </div>
//   );
// };



// SuggestionsData.jsx
// SuggestionsData.jsx
// SuggestionsData.jsx
// SuggestionsData.jsx
import React, { useState, useEffect, useRef } from "react";
import { Button, Input, Select, Tag, Collapse, Empty } from "antd";
import { SearchOutlined, CheckOutlined, CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Customstyles } from "../../components/styles/Customstyles";


const { Option } = Select;
const { Panel } = Collapse;

export const SuggestionsData = ({ selectedStyles = [], editor }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectedItems, setRejectedItems] = useState(new Set());
  const editorRef = useRef(editor);

  useEffect(() => {
    editorRef.current = editor;
  }, [editor]);

  const scanEditorForSuggestions = () => {

    if (!editorRef.current || !selectedStyles.length) {
      setSuggestions([]);
      return;
    }

    const editor = editorRef.current;



    // Correct highlight removal
    const layer = editor.getBody().querySelector(".suggestion-highlight-layer");
    if (layer) {
      layer.innerHTML = "";
    }

    const newSuggestions = [];

    selectedStyles.forEach((styleId) => {

      const style = Customstyles[styleId];
      if (!style) return;

      const matches = style.execute(editor, rejectedItems);
 
      if (!matches || matches.length === 0) return;

      // Rejected items skip செய்ய
      const filteredMatches = matches.filter(match => !rejectedItems.has(match.uid));
      if (filteredMatches.length === 0) return;


      newSuggestions.push({
        id: styleId,
        label: style.name,
        items: filteredMatches.map((match) => ({
          ...match,
          status: "pending",
          line: "Editor"
        }))
      });

    });

    setSuggestions(newSuggestions);
  };;

  useEffect(() => {

    editorRef.current = editor;

    if (!editor || selectedStyles.length === 0) {
      setSuggestions([]);
      return;
    }

    // Run immediately when styles applied
    scanEditorForSuggestions();

    const handleChange = () => {
      scanEditorForSuggestions();
    };

    editor.on("NodeChange keyup change", handleChange);

    return () => {
      editor.off("NodeChange keyup change", handleChange);
    };

  }, [editor, selectedStyles]);

  const handleAccept = (suggestionId, itemIndex) => {
    const suggestion = suggestions.find(s => s.id === suggestionId);
    if (!suggestion || !editorRef.current) return;

    const item = suggestion.items[itemIndex];
    if (!item) return;

    try {
      const editor = editorRef.current;


      const range = editor.getDoc().createRange();
      range.setStart(item.node, item.start);
      range.setEnd(item.node, item.end);

      editor.selection.setRng(range);
      editor.insertContent(item.suggested);

      // Remove overlay highlights
      const layer = editor.getBody().querySelector(".suggestion-highlight-layer");
      if (layer) {
        const marks = layer.querySelectorAll(`[data-uid="${item.uid}"]`);
        marks.forEach(mark => mark.remove());
      }

      // Update UI for only this item
      setSuggestions(prev =>
        prev.map(s =>
          s.id === suggestionId
            ? {
              ...s,
              items: s.items.map((i, idx) =>
                idx === itemIndex
                  ? { ...i, status: "accepted", processed: true }
                  : i
              )
            }
            : s
        )
      );
    } catch (e) {
      console.error("Error accepting suggestion:", e);
    }
  };;

  const handleReject = (suggestionId, itemIndex) => {
    const suggestion = suggestions.find(s => s.id === suggestionId);
    if (!suggestion || !editorRef.current) return;

    const item = suggestion.items[itemIndex];
    if (!item) return;

    try {
      const editor = editorRef.current;

      // Remove highlight
      const layer = editor.getBody().querySelector(".suggestion-highlight-layer");

      if (layer) {
        const marks = layer.querySelectorAll(`[data-uid="${item.uid}"]`);
        marks.forEach(mark => mark.remove());
      }

      setRejectedItems(prev => new Set(prev).add(item.uid));

      // Remove item from suggestions list
      setSuggestions(prev =>
        prev
          .map(s =>
            s.id === suggestionId
              ? { ...s, items: s.items.filter((_, idx) => idx !== itemIndex) }
              : s
          )
          .filter(s => s.items.length > 0)
      );

    } catch (e) {
      console.error("Error rejecting suggestion:", e);
    }
  };

  const handleAcceptAll = (suggestionId) => {
    const suggestion = suggestions.find(s => s.id === suggestionId);
    if (!suggestion || !editorRef.current) return;

    try {
      const editor = editorRef.current;
      const body = editor.getBody();

      editor.undoManager.transact(() => {

        // Only run once per style (important)
        const style = Customstyles[suggestionId];
        if (!style) return;

        const walker = document.createTreeWalker(
          body,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );

        let node;
        while ((node = walker.nextNode())) {
          if (!node.nodeValue) continue;

          // Replace ALL occurrences using global regex
          node.nodeValue = node.nodeValue.replace(
            style.pattern,   // already /gi
            (match) => {
              if (suggestionId === "degreeToSymbol") {
                return "°";
              }
              if (suggestionId === "correctIE_EGCommas") {
                return match + ",";
              }
              return match;
            }
          );
        }

        // Remove ALL highlights of this style
        const layer = body.querySelector(".suggestion-highlight-layer");
        if (layer) {
          suggestion.items.forEach(item => {
            const marks = layer.querySelectorAll(`[data-uid="${item.uid}"]`);
            marks.forEach(mark => mark.remove());
          });
        }

      });

      //Remove group from UI
      setSuggestions(prev =>
        prev.filter(s => s.id !== suggestionId)
      );

    } catch (e) {
      console.error("Error accepting all suggestions:", e);
    }
  };

  const handleRejectAll = (suggestionId) => {
    const suggestion = suggestions.find(s => s.id === suggestionId);
    if (!suggestion || !editorRef.current) return;

    try {
      const editor = editorRef.current;

      const layer = editor.getBody().querySelector(".suggestion-highlight-layer");

      if (layer) {
        suggestion.items.forEach(item => {
          const marks = layer.querySelectorAll(`[data-uid="${item.uid}"]`);
          marks.forEach(mark => mark.remove());
        });
      }

      setRejectedItems(prev => {
      const updated = new Set(prev);
      suggestion.items.forEach(item => updated.add(item.uid));
      return updated;
    });

      //Remove entire suggestion group from UI
      setSuggestions(prev =>
        prev.filter(s => s.id !== suggestionId)
      );

    } catch (e) {
      console.error("Error rejecting all suggestions:", e);
    }
  };

  const filteredSuggestions = suggestions
    .filter(s =>
      s.label.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter(s => {
      if (filter === "all") return true;
      return s.items.some(item => item.status === filter);
    });

  const totalSuggestions = filteredSuggestions.reduce(
    (sum, s) => sum + s.items.length, 0
  );

  const panelHeader = (suggestion) => {
    const pendingCount = suggestion.items.filter(
      item => item.status === "pending"
    ).length;

    return (
      <div className="flex flex-col  items-start w-full gap-4">
        <div className="flex items-center justify-between w-full gap-2">
          <span className="font-bold">{suggestion.label}</span>
          <Tag color="blue">{pendingCount}</Tag>
        </div>
        <div className="flex justify-start w-full">
          <div className="flex gap-2">
            <Button
              size="small"
              className="bg-white"
              icon={<CheckOutlined style={{ color: "green" }} />}
              onClick={(e) => {
                e.stopPropagation();
                handleAcceptAll(suggestion.id);
              }}
            >
              Accept All
            </Button>
            <Button
              size="small"
              className="bg-white danger-custom-btn"
              icon={<CloseOutlined style={{ color: "red" }} />}
              onClick={(e) => {
                e.stopPropagation();
                handleRejectAll(suggestion.id);
              }}
            >
              Reject All
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const scrollToSuggestion = (node, start, end) => {
  if (!node) return;
  const editor = editorRef.current;
  const body = editor.getBody(); // editor content container

  try {
    // Create range for selection
    const rng = editor.getDoc().createRange();
    rng.setStart(node, start);
    rng.setEnd(node, end);

    // Select in editor
    editor.selection.setRng(rng);

    // Focus editor
    editor.focus();

    // Scroll editor body so the node is centered
    const nodeRect = node.getBoundingClientRect();
    const bodyRect = body.getBoundingClientRect();
    body.scrollTop += nodeRect.top - bodyRect.top - bodyRect.height / 2;

    // Temporary highlight flash
    const mark = document.createElement("span");
    mark.style.background = "rgba(255, 255, 0, 0.5)";
    mark.style.transition = "background 1s";

    try {
      rng.surroundContents(mark);
      setTimeout(() => (mark.style.background = "transparent"), 1000);
      setTimeout(() => mark.replaceWith(...mark.childNodes), 1200);
    } catch (e) {
      console.warn("Highlight failed:", e);
    }
  } catch (err) {
    console.error("scrollToSuggestion error:", err);
  }
};

  return (
    <div className="h-full flex flex-col">
      <div className="flex flex-col items-start p-4 pl-0 border-b gap-2 ">
        <h2 className="text-lg font-medium">
          Suggestions ({totalSuggestions})
        </h2>
        <div className="flex gap-2 w-full">
          <Input
            placeholder="Search styles..."
            className="flex-1 "
            prefix={<SearchOutlined />}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Select value={filter} onChange={setFilter} className="w-32">
            <Option value="all">All</Option>
            <Option value="pending">Pending</Option>
            <Option value="accepted">Accepted</Option>
            <Option value="rejected">Rejected</Option>
          </Select>
        </div>
      </div>

      {filteredSuggestions.length > 0 ? (
        <div className="flex-1 overflow-auto p-3 pl-0 sugest-item">
          <Collapse accordion={false} bordered={false}>
            {filteredSuggestions.map(suggestion => (
              <Panel header={panelHeader(suggestion)} key={suggestion.id}>
                {suggestion.items.map((item, index) => (
                  <div key={index} className="mb-4 pb-2 flex justify-between items-center border-b border-dashed border-gray-300 cursor-pointer" onClick={() =>
                    scrollToSuggestion(item.node, item.start, item.end)
                  }>
                    <div className="flex flex-col">
                      <div className="flex gap-2 items-center">
                        <div className="text-sm text-gray-500 mb-1 text-red font-bold">Original:</div>
                        <div className=" bg-gray-50 ">
                          <div className="text-black font-bold">{item.text}</div>
                        </div>
                      </div>

                      <div className="flex gap-2 items-center">
                        <div className="text-sm text-gray-500 mb-1 text-green font-bold">Suggested:</div>
                        <div className=" bg-gray-50 ">
                          <div className="text-black font-bold">{item.suggested}</div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col justify-between">
                      {/* <div className="text-sm text-gray-500">{item.line}</div> */}
                      <div className="flex gap-2 mt-2">
                        <Button
                          type="primary"
                          icon={<CheckOutlined />}
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAccept(suggestion.id, index)
                          }}
                          disabled={item.status !== "pending"}
                        />
                        <Button
                          danger
                          icon={<CloseOutlined />}
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleReject(suggestion.id, index)
                          }}
                        />
                        {/* <Button
                            icon={<QuestionCircleOutlined />}
                            size="small"
                            onClick={() => {
                              // Find and select the text in editor
                              const spans = editorRef.current.dom.select(`span[data-style-id="${suggestion.id}"][data-original="${item.text}"]`);
                              if (spans.length > 0) {
                                const range = editorRef.current.dom.createRng();
                                range.selectNode(spans[0]);
                                editorRef.current.selection.setRng(range);
                                editorRef.current.focus();
                              }
                            }}
                          /> */}
                      </div>
                    </div>

                  </div>
                ))}
              </Panel>
            ))}
          </Collapse>
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center p-8">
          <Empty
            description={
              selectedStyles.length > 0
                ? "No suggestions found for the selected styles."
                : "Please select styles to see suggestions."
            }
          />
        </div>
      )}
    </div>
  );
};








